// components/GameSearch.vue
<script setup>
defineOptions({ name: 'GameSearch' });

import { ref, watch, onUnmounted } from 'vue';
import { useGamesStore } from '../stores/games/gamesStore';
import { debounce } from 'lodash';
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const gamesStore = useGamesStore();

// Estado para mostrar/ocultar búsqueda
const isSearchVisible = ref(false); 
const searchTerm = ref(''); 
let autoCloseTimeout = null;

// Use debounce to avoid too many API calls
const handleSearch = debounce(() => {
    const term = searchTerm.value.trim();
    console.log('Search term being sent:', term);
    gamesStore.searchGamesByName(term);
}, 300);

// Configurar cierre automático
const setupAutoClose = () => {
    clearTimeout(autoCloseTimeout); // Cancelar cualquier temporizador anterior
    autoCloseTimeout = setTimeout(() => {
        if (!searchTerm.value.trim()) {
            isSearchVisible.value = false; // Cerrar si no hay texto
        }
    }, 3000); // 3 segundos
};

// Observar cambios en el término de búsqueda
watch(searchTerm, (newTerm) => {
    handleSearch(newTerm);
    if (newTerm.trim()) {
        clearTimeout(autoCloseTimeout); // Si hay texto, cancelar el cierre automático
    } else {
        setupAutoClose(); // Si el campo está vacío, reconfigurar el temporizador
    }
});

// Función para alternar visibilidad search abrir y cerrar la lupa
const toggleSearchVisibility = () => {
    isSearchVisible.value = !isSearchVisible.value;

    if (isSearchVisible.value) {
        setupAutoClose(); // Configurar cierre automático al abrir
    } else {
        clearTimeout(autoCloseTimeout); // Cancelar el temporizador si se cierra manualmente
        searchTerm.value = ''; // Limpiar el término de búsqueda
    }
};

// Limpieza
onUnmounted(() => {
    if (autoCloseTimeout) {
        clearTimeout(autoCloseTimeout);
    }
});
</script>

<template>
    <!-- Botón de alternancia -->
    <button class="search-toggle" @click="toggleSearchVisibility">
        <font-awesome-icon :icon="isSearchVisible ? 'times' : 'search'" />
    </button>

    <!-- Campo de búsqueda -->
    <input
        v-if="isSearchVisible"
        type="search"
        v-model="searchTerm"
        class="search-input"
        :placeholder="t('app.searchGames')"
    />
</template>

<style scoped>
@import '../assets/styles/main.css';
</style>